import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import clsx from 'clsx';
import { Modal } from 'react-bootstrap';
import { Button, ButtonColorType } from '../Button';
import FormModalContext from './FormModal.context';
import { IFormModalProviderProps } from './FormModalProvider.types';
// @ts-ignore
import modalCloseIcon from '../../assets/icons/modal-close.svg';

import './FormModalProviderDeprecated.scss';
import { NoneButton } from '../AttachmentTag/AttachmentTag';

const FormModalProviderDeprecated: React.FC<IFormModalProviderProps> = (
  props: IFormModalProviderProps
) => {
  const { Provider } = FormModalContext;
  const {
    children,
    className,
    stepsDefinition,
    show,
    onHide,
    header,
    mode,
    onSubmit,
    onStepChange,
    type,
    finishButtonText,
    onAlternativeFinishAction,
    alternativeFinishButtonText,
    hideBackButton,
    locked,
    toastContainerId,
    finishButtonId,
    nextButtonId,
    backButtonId
  } = props;
  const [actualStep, setActualStep] = React.useState(0);

  React.useEffect(() => setActualStep(0), [show]);

  return (
    <Modal
      className={clsx([
        'modal',
        'fade',
        className ?? '',
        type ?? 'center',
        mode === 'Add' ? 'modal-with-footer' : ''
      ])}
      show={show}
      backdrop="static"
      keyboard={false}
      onHide={() => {
        if (onHide) {
          onHide();
        }
      }}
    >
      <form onSubmit={onSubmit}>
        <Provider value={actualStep}>
          <div className="modal-header">
            <div className="modal-header-close-button">
              <NoneButton
                type="button"
                onClick={() => {
                  if (onHide) {
                    onHide();
                  }
                }}
              >
                <img src={modalCloseIcon} alt="close-icon" />
              </NoneButton>
            </div>
            <div className="modal-header-text">{header}</div>
            <div className="modal-tab-buttons">
              {stepsDefinition
                .sort((n1, n2) => n1.pageNumber - n2.pageNumber)
                .map(def => {
                  return (
                    <button
                      type="button"
                      key={`step-${def.pageNumber}`}
                      className={`${
                        actualStep === def.pageNumber ? 'button-active' : ''
                      } text-regular`}
                      onClick={e => {
                        e.preventDefault();
                        if (onStepChange) {
                          onStepChange(actualStep, def.pageNumber);
                        }
                        if (!def.disable) {
                          setActualStep(def.pageNumber);
                        }
                      }}
                    >
                      {def.title}
                    </button>
                  );
                })}
            </div>
          </div>
          <div className={`h3-medium b-modal-body ${type ?? 'center'}`}>
            {children}
          </div>
          {mode === 'Add' && (
            <div className="modal-footer">
              <div id={toastContainerId} className="toast-container" />
              {actualStep !== 0 && !hideBackButton ? (
                <Button
                  className="modal-footer-button m-r-12"
                  type="button"
                  onClick={() => {
                    if (onStepChange) {
                      onStepChange(actualStep, actualStep - 1);
                    }
                    if (!stepsDefinition[actualStep - 1].disable) {
                      setActualStep(actualStep - 1);
                    }
                  }}
                  colorType={ButtonColorType.WHITE}
                  text="Back"
                  testId={backButtonId || 'back_button'}
                />
              ) : null}
              {actualStep === stepsDefinition.length - 1 ? (
                <>
                  {onAlternativeFinishAction ? (
                    <Button
                      className="modal-footer-button m-r-12"
                      type="button"
                      onClick={() => onAlternativeFinishAction()}
                      text={alternativeFinishButtonText ?? 'Close'}
                      colorType="grey"
                      testId="close_button"
                    />
                  ) : null}
                  <Button
                    className="modal-footer-button"
                    type="submit"
                    text={finishButtonText ?? 'Finish'}
                    disabled={locked}
                    testId={finishButtonId || 'back_button'}
                  />
                </>
              ) : (
                <Button
                  className="modal-footer-button"
                  type="button"
                  onClick={() => {
                    if (onStepChange) {
                      onStepChange(actualStep, actualStep + 1);
                    }
                    if (!stepsDefinition[actualStep + 1].disable) {
                      setActualStep(actualStep + 1);
                    }
                  }}
                  text="Next step"
                  disabled={locked}
                  testId={nextButtonId || 'next_button'}
                />
              )}
            </div>
          )}
        </Provider>
      </form>
      <ReactTooltip id="modalTooltip" multiline />
    </Modal>
  );
};

export default FormModalProviderDeprecated;
